import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/VDeVuyst.png'
import _imports_1 from '@/assets/loading.gif'
import _imports_2 from '@/assets/LogoDeVuyst.png'


const _withScopeId = n => (_pushScopeId("data-v-266f1c38"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "loading"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loadingDiv" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "loadingLogo",
    src: _imports_0
  }),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("img", {
    class: "loadingImg",
    src: _imports_1,
    alt: "loading"
  })
], -1))
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = {
  key: 1,
  class: "TumiContent"
}
const _hoisted_5 = { class: "TumiOverOns" }
const _hoisted_6 = {
  class: "container text-center",
  id: "OO"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "mb-5"
}, null, -1))
const _hoisted_8 = {
  key: 0,
  class: "TumiSlogan"
}
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = { class: "row text-start mt-3 mb-5" }
const _hoisted_11 = {
  key: 0,
  class: "col-sm-12 col-lg-6"
}
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = {
  key: 1,
  class: "col-sm-12 col-lg-6"
}
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = {
  key: 0,
  class: "text-center TumiAdresse pt-1 pb-1",
  id: "RO"
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container TumiSocials text-center" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Map = _resolveComponent("Map")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
      : _createCommentVNode("", true),
    _createVNode(_Transition, { name: "header" }, {
      default: _withCtx(() => [
        (_ctx.image && !_ctx.loading)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              id: "Header",
              class: "TumiHeader text-center ps-3 pe-3",
              style: _normalizeStyle({'background-image': `url(` + _ctx.image + `)`})
            }, null, 4))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_ctx.content && !_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              (_ctx.content.CONTENT_SLOGAN)
                ? (_openBlock(), _createElementBlock("h2", _hoisted_8, [
                    _createElementVNode("span", {
                      innerHTML: _ctx.content.CONTENT_SLOGAN
                    }, null, 8, _hoisted_9)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_10, [
                (_ctx.content.CONTENT_OVERONSTEXT)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createElementVNode("span", {
                        innerHTML: _ctx.content.CONTENT_OVERONSTEXT
                      }, null, 8, _hoisted_12)
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.content.CONTENT_OVERONSTEXT2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                      _createElementVNode("span", {
                        innerHTML: _ctx.content.CONTENT_OVERONSTEXT2
                      }, null, 8, _hoisted_14)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          (_ctx.content.CONTENT_ADRES)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.content.CONTENT_ADRES), 1))
            : _createCommentVNode("", true),
          _createVNode(_component_Map),
          _hoisted_16
        ]))
      : _createCommentVNode("", true)
  ], 64))
}